/**
 * Created by staffanrantzow on 16/03/16.
 */

/* @flow */
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import { InputField, GeneralError, SpinnerButton } from 'components';
import { Utils, UserService } from 'frilans-finans';
import ConfirmEmail from './confirm-email';

import styles from './change-password.scss';

export class ChangePassword extends Component {

  static propTypes = {
    emailConfirmed: PropTypes.bool
  }

  constructor (props) {
    super(props);

    this.state = {
      formValues: {
        password: {},
        repeatPassword: {},
        currentPassword: {}
      },
      errorMessage: null,
      passwordNotEqual: false,
      posting: false,
      postError: false,
      updated: false,
      showErrorWithoutBlur: false
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.callback = this.callback.bind(this);
  }

  callback (name, values) {
    var tempFormValues = this.state.formValues;

    Object.assign(tempFormValues[name], values);
    this.setState({formValues: tempFormValues}, () => {
      if (this.state.showErrorWithoutBlur) {
        this.validatePassword();
      }
    });
  }

  validatePassword () {
    let equal = this.state.formValues.password.value === this.state.formValues.repeatPassword.value;

    this.setState({
      passwordNotEqual: !equal
    });

    return equal;
  }

  updateUser () {
    let params = {
      password: this.state.formValues.password.value,
      currentPassword: this.state.formValues.currentPassword.value
    };

    UserService.update(params)
      .then(this.handleSuccess.bind(this))
      .catch(this.handleError.bind(this));

    this.setState({
      posting: true,
      updated: false,
      postError: false
    });
  }

  handleSuccess () {
    this.setState({
      posting: false,
      updated: true,
      postError: false
    });
  }

  handleError (error) {
    let errors = UserService.getError(error);

    this.setState({
      posting: false,
      updated: false,
      postError: true,
      errorMessage: errors
    });
  }

  onSubmit (e) {
    e.preventDefault();

    this.setState({showErrorWithoutBlur: true}, () => {
      if (Utils.validateInputValues(this.state.formValues) && this.validatePassword()) {
        this.setState({
          loading: true
        }, this.updateUser);
      }
    });
  }

  disabled () {
    return !this.props.emailConfirmed;
  }

  renderError () {
    if (this.state.passwordNotEqual) {
      return (
        <p className='error show'><Translate content='PASSWORD_NOT_EQUAL'/></p>
      );
    }

    return false;
  }

  renderPostError () {
    if (this.state.postError) {
      if (!this.state.errorMessage) {
        return (<GeneralError />);
      } else {
        return (
          <div>
            {this.state.errorMessage.map((error, i) => {
              return (
                <p className="error" key={i}>{error}</p>
              );
            })}
          </div>
        );
      }
    }
  }

  renderPostSuccess () {
    if (!this.state.posting && this.state.updated) {
      return (
        <p className='info'><Translate content='SETTINGS_UPDATED' /></p>
      );
    }
  }

  render () {
    return (
      <div className='change-password'>
        <div className="row">
          <div className="col-md-6 col-sm-8">
            <h2><Translate content='CHANGE_PASSWORD'/></h2>

            <ConfirmEmail />

            <p className={styles['text-body']}>
              <Translate content='PASSWORD_ERROR'/>
            </p>
            <form action='' noValidate>
              <InputField type='password' name='currentPassword'
                placeholder={proxyCounterpart('CURRENT_PASSWORD')} callback={this.callback}
                required='true' errorMessage={proxyCounterpart('PASSWORD_ERROR')}
                disabled={this.disabled().toString()}
                showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
              <InputField type='password' name='password'
                placeholder={proxyCounterpart('NEW_PASSWORD')} callback={this.callback}
                required='true' minLength='5' validationType='passwordRegistration'
                disabled={this.disabled().toString()}
                errorMessage={proxyCounterpart('PASSWORD_ERROR')}
                showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
              <InputField type='password' name='repeatPassword'
                placeholder={proxyCounterpart('REPEAT_PASSWORD')} callback={this.callback}
                required='true' minLength='5' validationType='passwordRegistration'
                disabled={this.disabled().toString()}
                errorMessage={proxyCounterpart('PASSWORD_ERROR')}
                showErrorWithoutBlur={this.state.showErrorWithoutBlur} />

              {this.renderError()}
              {this.renderPostSuccess()}
              {this.renderPostError()}

              <div className='button-wrapper'>
                <SpinnerButton text={proxyCounterpart('SAVE_SETTINGS')}
                  loading={this.state.posting}
                  classes='btn'
                  disabled={this.disabled()}
                  callback={this.onSubmit} />
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    emailConfirmed: state.user.emailConfirmed
  };
};

export default connect(mapStateToProps)(ChangePassword);



/** WEBPACK FOOTER **
 ** ./src/views/settings/change-password/change-password.js
 **/